function voucher(state = {}, action) {
  switch (action.type) {
    case 'GET_VOUCHER':
      return { ...action.vouchers };

    case 'REMOVE_VOUCHER':
      return {};

    default:
      return state;
  }
}

export default voucher;
